import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { useEffect, useState } from "react";
import Input from "../../components/FormComponents/Input";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import Button from "../../components/FormComponents/Button";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import ClusterManModal from "./ClusterManModal";
import { mapArrayToObject } from "../../commonFunctions/arrayFunc";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import { useModalContext } from "../../context/ModalContext";
import { BASE_URL } from "../../constant/constant";

const DomainManager = () => {
  const { getUserConfirmationForDelete } = useModalContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [domainSearch, setDomainSearch] = useState("");
  const [allDomainData, setAllDomainData] = useState([]);
  const [allApplication, setAllApplication] = useState([]);
  const [allAppsObj, setAllAppsObj] = useState({});

  const filteredDomains = allDomainData.filter(
    (domain) =>
      domain.domain_name.toLowerCase().includes(domainSearch.toLowerCase()) ||
      domain.title.toLowerCase().includes(domainSearch.toLowerCase())
  );

  const addDomain = async (domainData) => {
    try {
      const { data, message } = await axiosInstance.post(`/domain`, domainData);
      setAllDomainData([...allDomainData, data]);
      setIsModalOpen(false);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const editDomain = async (domainData, id) => {
    try {
      const { message } = await axiosInstance.put(`/domain/${id}`, domainData);
      setAllDomainData((prevDomains) =>
        prevDomains.map((domain) => (domain.id === id ? { ...domain, ...domainData } : domain))
      );
      setIsModalOpen(false);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const openAddDomainModal = () => {
    setEditData({
      id: "",
      domain_name: "",
      title: "",
      apps: [],
      external_apps: [],
      login_image: "",
      favicon: "",
      app_logo: "",
      allow_notifications: false,
      sandbox: false
    });
    setIsModalOpen(true);
  };

  const openEditDomainModal = (data) => {
    setEditData(data);
    setIsModalOpen(true);
  };

  const deleteDomain = async (id, name) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete(name);
      if (!userConfirmed) return;
      const { message } = await axiosInstance.delete(`/domain/${id}`);
      setAllDomainData(allDomainData.filter((domain) => domain.id !== id));
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleDomainSearchInputChange = (e) => {
    setDomainSearch(e.target.value);
  };

  const getAllApps = async () => {
    try {
      const { data } = await axiosInstance.get(`/allapps`);
      setAllApplication(data);
      getAllAppObject(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  // const getAllOrgs = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/organisations`);
  //     setAllOrgs(data);
  //   } catch (error) {
  //     handleApiError(error);
  //   }
  // };

  const getAllAppObject = (data) => {
    const { result } = mapArrayToObject(data);
    setAllAppsObj(result);
  };

  const fetchAllDomains = async () => {
    try {
      const { data } = await axiosInstance.get(`/domain`);
      setAllDomainData(data);
      filterApps(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  //filter apps present in each domain if that app is deleted
  const filterApps = async (data) => {
    if (allAppsObj) {
      const newDomainData = data.map((domainData) => {
        const filteredApps = domainData.apps.filter((app) => allAppsObj[app.app_id]);
        return { ...domainData, apps: filteredApps };
      });
      setAllDomainData(newDomainData);
    }
  };

  const initialFetching = async () => {
    try {
      // setIsLoader(true);
      await getAllApps();
      // await getAllOrgs();
      // await fetchAllDomains();
    } catch (error) {
      handleApiError(error);
    } finally {
      // setIsLoader(false);
    }
  };

  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.keys(allAppsObj).length > 0) {
      fetchAllDomains();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allAppsObj]);

  return (
    <div className="flex_column pt_4" style={{ userSelect: "text" }}>
      <div className="top_border">
        <div className="d_flex justify_between mb_2 p_3">
          <div className="d_flex" style={{ width: "300px" }}>
            <Input
              placeholder="Search Domains..."
              value={domainSearch}
              onChange={handleDomainSearchInputChange}
              containerStyle={{ position: "relative", width: "80%" }}
              inputBoxStyle={{ paddingLeft: "28px", height: "36px" }}
            />
            <MaterialIcon
              name="search"
              className="position_relative font_size_large"
              style={{ top: "8px", left: "-232px" }}
            />
          </div>
          <Button onClick={openAddDomainModal}>Add Domain</Button>
        </div>
      </div>
      <div className="user_table">
        <table>
          <thead>
            <tr>
              <th>Domain</th>
              <th>Apps</th>
              <th>Title</th>
              <th>LoginImage</th>
              <th>Favicon</th>
              <th>App logo</th>
              <th>Custom Login HTML</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredDomains.length > 0 ? (
              filteredDomains.map((domain) => (
                <tr key={domain.id}>
                  <td>{domain.domain_name}</td>
                  <td>{domain.apps.map((app) => allAppsObj[app.app_id]?.name).join(", ")}</td>
                  <td>{domain.title}</td>
                  <td>
                    {domain?.login_image ? (
                      <img
                        src={`${BASE_URL}/api/v1/public/${domain.login_image}`}
                        alt="logo"
                        className="app_card_image"
                        onError="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD…AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/9k="
                      />
                    ) : (
                      <MaterialIcon name="deployed_code" className="apps default_org_img" />
                    )}
                  </td>
                  <td>
                    {domain?.favicon ? (
                      <img
                        src={`${BASE_URL}/api/v1/public/${domain.favicon}`}
                        alt="logo"
                        className="app_card_image"
                        onError="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD…AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/9k="
                      />
                    ) : (
                      <MaterialIcon name="deployed_code" className="apps default_org_img" />
                    )}
                  </td>
                  <td>
                    {domain?.app_logo ? (
                      <img
                        src={`${BASE_URL}/api/v1/public/${domain.app_logo}`}
                        alt="logo"
                        className="app_card_image"
                        onError="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD…AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/9k="
                      />
                    ) : (
                      <MaterialIcon name="deployed_code" className="apps default_org_img" />
                    )}
                  </td>

                  <td>
                    {domain.enable_custom_login_html && domain.custom_login_html ? (
                      <div className="custom_login_thumbnail">
                        <div
                          className="custom_login_thumbnail_content"
                          dangerouslySetInnerHTML={{ __html: domain.custom_login_html }}
                        />
                      </div>
                    ) : (
                      "Not Configured"
                    )}
                  </td>

                  <td className="user_table_btn">
                    <ButtonActionIcon type="edit" size="xsm" onClick={() => openEditDomainModal(domain)} />
                    <ButtonActionIcon type="delete" size="xsm" onClick={() => deleteDomain(domain.id, domain.name)} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No Domain Found</td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <BuilderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalName={editData?.id?.length === 0 ? "Add Domain" : "Edit Domain"}
      >
        <div style={{ width: "600px", maxWidth: "700px" }}>
          <ClusterManModal
            allApplication={allApplication}
            editData={editData}
            addDomain={addDomain}
            editDomain={editDomain}
          />
        </div>
      </BuilderModal>
    </div>
  );
};

export default DomainManager;
